import HostWizard from './HostWizard';
import Statistics from './Statistics';

export const routes = [HostWizard, Statistics];



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/routes/routes.js